export default theme => ({
    title: {
        fontSize: 16,
        fontWeight: 500,
        paddingLeft: 50
    },
    date: {
        fontWeight: "initial",
        fontSize: theme.textSizes[1]
    },
    date__finished : {
        "& div p": {
            color: theme.palette.disabled.main + ' !important'
        }
    },
    main: {
        background: theme.palette.blue.light + ' !important',
        color: theme.palette.blue.dark + ' !important',
        '& *': {
            background: theme.palette.blue.light + ' !important',
            color: theme.palette.blue.dark + ' !important'
        }
    },
    rowButtonsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    date_wrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    date_container: {
        display: 'flex',
        //flexDirection: 'column'
    },
    waitingText: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    recording_download__main:{
        color: theme.palette.primary.main + ' !important',
        "& *": {
            color: theme.palette.primary.main + ' !important'
        },
        "&:hover *": {
            color: theme.palette.primary.main + ' !important'
        }
    },
    recording_download__main__disabled: {
        color: theme.palette.blue.disabled + ' !important',
        '& *': {
            color: theme.palette.blue.disabled + ' !important'
        }
    }
});